<table class="table table-fixed table-hover mb-0 table-with-labels">
    <thead>
    <tr>
        <th monTableSort
            class="col-20"
            [monStartAsc]="true"
            [monSortBy]="'first_name'"
            [monSortDirection]="currentSort.direction"
            [monCurrentlySortedBy]="currentSort.by"
            (monOnSorted)="handlePageSort($event)">
            {{ 'User' | translate }}
        </th>
        <th monTableSort class="col-6 text-center"
            [monSortBy]="'last_login_at'"
            [monSortDirection]="currentSort.direction"
            [monCurrentlySortedBy]="currentSort.by"
            (monOnSorted)="handlePageSort($event)">
            {{ 'Latest login' | translate }}
        </th>
        <!--<th class="col-md-12 text-center" translate>Domains</th>-->
        <th class="col-4 text-right" translate>Role</th>
        <th class="col-5"> </th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let user of extendedUsers">
        <td class="vertical-align-middle text-left">
            <div class="d-flex text-ellipsis">
                <div>
                    <mon-avatar [initials]="user.avatarInitials"
                              [size]="30"
                              [useAutoColor]="true">
                    </mon-avatar>
                </div>
                <div [attr.data-test]="('user-' + user.getName()) | e2eAttributeEncoding" class="ml-2 text-ellipsis">
                    <span>{{ user.getName() }}</span>
                    <br/>
                    <div class="d-flex text-ellipsis">
                        <div class="pr-1">
                            <a [class]="['ADMIN', 'USERS', 'MAIL'] | monIcons"
                               [href]="'mailto:' + user.email"
                               [title]="user.email">
                            </a>
                        </div>
                        <div class="text-grey text-ellipsis">
                            {{ user.email }}
                        </div>
                    </div>
                </div>
            </div>
            <label-table [assignedLabels]="user.labels"
                         *ngIf="showLabels"
                         (getLabels)="getLabels()"
                         [existingLabels]="allLabels"
                         (onUpdateLabel)="updateUser(user)">
            </label-table>
        </td>
        <td class="vertical-align-middle text-center">
            <table-date *ngIf="user.last_login_at !== null" [date]="user.last_login_at">
            </table-date>
            <div class="text-grey outer-t-medium outer-b-medium"
                 *ngIf="user.last_login_at === null"
                 translate>
                Never
            </div>
        </td>
        <!--<td class="vertical-align-middle text-center">
            <a class="btn btn-secondary">
                <span class="fas fa-folder"></span>
                <span class="text-grey">12</span>
            </a>
        </td>-->
        <td class="vertical-align-middle text-right">
            <span class="text-grey">{{ user.customer_admin ? 'Admin' : 'Normal' }}</span>
        </td>
        <td class="text-right vertical-align-middle" [attr.aria-label]="'Actions' | translate">
            <!--<a class="btn btn-secondary" ui-sref="base.customer.users.user({user_id: user.id})">See</a>-->
            <div class="btn-group ngb-dropdown-inline-flex" ngbDropdown>
                <button [attr.data-test]="('action-dropdown-' + user.getName()) | e2eAttributeEncoding" ngbDropdownToggle class="btn btn-border-radius btn-secondary">
                    <span translate>Actions</span>
                    <span [class]="['ADMIN', 'USERS', 'ACTION'] | monIcons"></span>
                </button>
                <ul class="dropdown-menu pull-right" ngbDropdownMenu role="menu"
                    aria-labelledby="single-button">
                    <!--<li role="menuitem"><a href="#"><span class="fas fa-comment outer-r-mini"></span>
                        {{'Send message' | translate}}</a></li>-->
                    <!--<li role="menuitem"><a href="#"><span
                            class="fas fa-check-circle outer-r-mini"></span> {{'Add task' |
                        translate}}</a></li>-->
                    <!--<li role="menuitem"><a href="#"><span
                            class="fas fa-circle outer-r-mini"></span>
                        {{'Invite to new project' | translate}}</a></li>-->
                    <li *ngIf="isAdmin" role="menuitem">
                        <a (click)="editUser(user)"
                           [attr.data-test]="('edit-user-button-' + user.getName()) | e2eAttributeEncoding"
                           monEventTrigger="actionTrigger"
                           [monEventParams]="{action: 'edit-user-btn'}"
                           role="button">
                            <span [class]="['ADMIN', 'USERS', 'EDIT_USER'] | monIcons" class="outer-r-mini"></span>
                            <span translate>Edit user</span>
                        </a>
                    </li>
                    <li class="divider"></li>
                    <li *ngIf="isAdmin" role="menuitem">
                        <a class="cursor-pointer"
                           monModalPrompt="{{'You are about to delete' | translate}} <span data-test='user-to-delete' class='text-link'>{{user.getName()}}</span> {{'please type' | translate}} <code data-test='delete-word' >Delete</code> {{'to confirm this action' | translate}}"
                           monEventTrigger="actionTrigger"
                           [attr.data-test]="('delete-user-button-' + user.getName()) | e2eAttributeEncoding"
                           [monEventParams]="{action: 'delete-user-btn'}"
                           (monModalPromptAction)="onConfirmDelete($event, user)">
                            <span [class]="['ADMIN', 'USERS', 'DELETE'] | monIcons" class="outer-r-mini"></span>
                            <span translate>Delete user</span>
                        </a>
                    </li>

                </ul>
            </div>
        </td>
    </tr>
    </tbody>
</table>
